import { render, staticRenderFns } from "./PersistCargaSaraivaView.vue?vue&type=template&id=73057df2&"
import script from "./PersistCargaSaraivaView.vue?vue&type=script&lang=ts&"
export * from "./PersistCargaSaraivaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports